angular.module('shared').factory('AssetLibraryService', ["ReactModal", function(ReactModal) {
  var AssetLibraryService;
  AssetLibraryService = {
    open: function(params) {
      return ReactModal.open({
        component: 'AssetDrawer',
        drawer: true,
        props: params
      });
    }
  };
  return AssetLibraryService;
}]);
